<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    label: String,
  },

  setup(props, context) {
    return () => {
      return (
        <div class="label-text">
          <label class="label">{props.label}：</label>
          <div class="text">
            {context.slots.default && context.slots.default()}
          </div>
        </div>
      );
    };
  },
});
</script>
<style lang="scss" scoped>
.label-text {
  display: flex;
  flex-wrap: wrap;
  // .label {
  // }
  // .text {
  // }
}
</style>
